module.exports = __webpack_public_path__ + "static/media/UDAF_logo.9be42885.png";